<template>
  <div class="game_tags fs_12 flex_center">
    <div v-for="tg in tags" :key="tg.tagId" class="game_tg">
      
      <!-- 边框文字 -->
      <div  
        v-if="tg.tagType === 1"
        class="tag_1"
        :style="{
          borderColor: tg.labelInfo,
          color: tg.labelInfo,
        }"
      >{{ tg.labelName }}</div>
      <!-- 填充 -->
      <div 
        v-if="tg.tagType === 2"
        class="tag_2"
        :style="{
          backgroundColor: tg.background,
          color: tg.labelInfo,
          borderColor: tg.background,
        }"
      >{{ tg.labelName }}</div>
      <!-- 图片 -->
      <div v-if="tg.tagType === 3" class="tag_3">
        <img :src="tg.pictureTag" :alt="tg.labelName" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  },
}
</script>

<style scoped lang="scss">
.game_tags {
  flex-wrap: wrap;
  justify-content: start;
}
.game_tg {
  display: flex;
  align-items: center;
  height: 15px;
  margin-top: 4px;
  margin-right: 3px;
}
.tag_1, .tag_2 {
  font-size: 10px;
  padding: 1px 2px;
  line-height: 11px;
  border-radius: 2px;
  border: 1px solid #fff;
}

.tag_3 {
  img {
    height: 15px;
  }
}
</style>